export default __webpack_public_path__ + "static/media/Hack_Banner768.9ecab88f.png";